import React from "react";
import SearchForm from "./SearchForm";
import Stories from "./Stories";
import Buttons from "./Buttons";
function App() {
  return (
    <>
      <SearchForm></SearchForm>
      <Buttons></Buttons>
      <Stories></Stories>
    </>
  );
}

export default App;
